<template>
  <v-card>
    <v-container fluid>
      <v-row dense class="text-h5">
        <v-col>
          {{ template.name }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization
            permissionKey="configuration_template"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="authorization"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="templateName = template.name"
                >
                  eva-edit-outline
                </v-icon>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">Editar protocolo</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="templateName"
                          label="Nome"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </authorization>

          <authorization
            permissionKey="configuration_template"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-icon v-if="authorization" @click="deleteTemplate">
              eva-trash-outline
            </v-icon>
          </authorization>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <TemplateItemsTable
            :template="template"
            :medicines="medicines"
            :refreshList="refreshList"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import TemplateItemsTable from "./template_items.vue";

  export default {
    name: "MedicineListItem",
    props: {
      template: Object,
      medicines: Array,
      refreshList: Function,
    },
    components: {
      TemplateItemsTable,
    },
    data() {
      return {
        dialog: null,
        templateName: "",
      };
    },
    methods: {
      deleteTemplate() {
        if (confirm("Você realmente deseja deletar esse protocolo?")) {
          this.apolloMutate({
            mutation: require("@/graphql/template/delete_template.gql"),
            variables: {
              templateId: this.template.id,
            },
          }).then(() => {
            this.refreshList();

            this.$store.dispatch("createNotification", {
              message: "Protocolo deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.templateName = this.template.name;
      },
      save() {
        this.apolloMutate({
          mutation: require("@/graphql/template/save_template.gql"),
          variables: {
            templateId: this.lodash.get(this.template, "id", ""),
            name: this.templateName,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
    },
  };
</script>

<style lang="sass" scoped></style>
